'use client';

// import momenttz from 'moment-timezone';
import MatchMinute from '@/components/client/MatchMinute';
import { useMatchData } from '@/hooks/useMatchData';
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const MatchHeader = ({ matchDB }) => {
  const matchLive = useMatchData(matchDB?.id);

  let match = {
    ...matchDB,
    ...matchLive,
  };
  
  return (
    <div className="text-center p-2">
    <div className=" text-xxs @md:text-xs mb-2 dark:text-stroke-o3 font-semibold">
      {match.league && match.league.name} 
      <span className='mx-1 @md:mx-2'>|</span> 
      Vòng {match.round} 
      <span className='mx-2 hidden @md:inline-block'>|</span>  
      <span className='dark:text-league-dark-detail hidden @md:inline-block'>{dayjs.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("DD-MM-YYYY")}</span> 
    </div>
    <div className="text-xxs @md:text-xs font-bold whitespace-nowrap">
      <span className='text-vibrant-red dark:text-golden-yellow'>{dayjs.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("HH:mm")} (GMT +7)</span> 
      <span className='mx-1 @md:hidden'>|</span> 
      <span className='dark:text-league-dark-detail @md:hidden text-wrap'>{dayjs.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("DD-MM-YYYY")}</span> 

    </div>

    <div className="flex items-center justify-center mt-2">
      <span className="text-2xl font-semibold text-dark-gray dark:text-stroke-o3">{match.homeScore}</span>
      <span className="text-gray-500 mx-4 text-sm dark:text-stroke-o3"><MatchMinute matchId={match.id}/></span>
      <span className="text-2xl font-semibold text-dark-gray dark:text-stroke-o3">{match.awayScore}</span>
    </div>

    <div className="text-gray-500 text-xs dark:text-blur-gray">
      <span>
        <span>({match.homeHalfScore}</span>
        <span>-</span>
        <span>{match.awayHalfScore}</span>
      </span>
      <span>, </span>
      <span>
        <span>{match.homeScore}</span>
        <span>-</span>
        <span>{match.awayScore})</span>
      </span>
    </div>
  </div>
  );
};

export default MatchHeader;